import React, { Component } from 'react';
import Header from '../../components/main.header.component';


class Shade extends Component {
  render() {
    return (
      <div className="Shade">
        <Header
          props={this.props}
        />
          <div className="shade-headline">
            Shade <span role="img" aria-label="Sungalsses">😎</span>
          </div>
          <div className="shade-text">
            <h4>A Video-Social Media Application for iOS.</h4>
            <ul>
              <li>Built with React-Native (with Redux)</li>
              <li>Utilizes AWS S3 for video storage</li>
              <li>Uses Node.JS/PostgreSQL for the backend.</li>
            </ul>
          Currently in development (beta release on Apple TestFlight).
          <br />
            <div id="shade-link">
              <a href="https://github.com/cozpon/shadee" target='_blank' rel="noopener noreferrer">
                View it on Github
              </a>
            </div>
          </div>
          <div className="shade-pink">
            <img src="/images/shade/shade_phone.png" id="shade-phone" alt=""/>
          </div>
          <div className="shade-goals">
            <div className="shade-text">
              <h2>Features</h2>
              <ul>
                <li> Share your Shade's instantly, allowing users to vote them Extra or Basic. </li>
                <li> Rumor Mill allows you to spread anonymous rumors about users, complete with a Rumor Credibility Meter. </li>
                <li> Full Website version coming soon, allowing password recovery, email change, and access to your account's Shade Feed. </li>
              </ul>
              <h2>
                Video Demo
              </h2>
              <div className="mobile-link">
                <a href="https://www.youtube.com/watch?v=sRKQTn9YZPI" target='_blank' rel="noopener noreferrer">
                  View on Youtube
                </a>
              </div>
              <div className="youtube-container">
                <iframe className="player" type="text/html" width="100%" height="100%"
                  src="https://www.youtube.com/embed/sRKQTn9YZPI"
                  frameborder="0"
                  title="shade-youtube-video"
                />
              </div>
            </div>
          </div>

          <div className="shade-colors-text">
          <h2>Colors</h2>
          </div>
          <div className="shade-colors">
            <img src="/images/shade/red.png" id="shade-color-tab" alt="red"/>
            <img src="/images/shade/orange.png" id="shade-color-tab" alt="orange"/>
            <img src="/images/shade/teal.png" id="shade-color-tab" alt="blue"/>
            <img src="/images/shade/lightgrey.png" id="shade-color-tab" alt="lgrey"/>
            <img src="/images/shade/darkgrey.png" id="shade-color-tab" alt="dgrey"/>
          </div>
          <div className="shade-yellow">
            <img src="/images/shade/shade_1.jpg" id="shade-phone" alt="1"/>
            <img src="/images/shade/shade_3.jpg" id="shade-phone" alt="3"/>
            <img src="/images/shade/shade_2.jpg" id="shade-phone" alt="2"/>
          </div>
      </div>
    );
  }
}

export default Shade;
